import { useState } from 'react'; 
import { useEffect } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import MessageBox from '../../MessageBox/MessageBox';
import Button from '@mui/material/Button';
import { IAttachmentDB } from '../StarsAdding/StarsAdding';
import './AttachmentSegment.css';
import { useNavigate } from 'react-router-dom';

export interface IAttachmentInput {
  position: File;
  picture: File;
}

interface props {
  data: IAttachmentDB;
}

const EMPTY_FILE_BOX_CONTENT = 'Naciśnij tu, aby wybrać plik';
const SUBMIT_BUTTON_TITLE = 'ZAPISZ ZAŁĄCZNIKI';

const AttachmentSegment = (props: props) => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
 
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(false);
  
  const [positionLabel, setPositionLabel] = useState(EMPTY_FILE_BOX_CONTENT);
  const [pictureLabel, setPictureLabel] = useState(EMPTY_FILE_BOX_CONTENT);
  
  useEffect(() => {
    const isAddingStar = sessionStorage.getItem("isAddingStar");
  
    if (isAddingStar === "true") {
      console.log("Dodawanie nowej gwiazdy - ukrywanie labeli");
      setPositionLabel(EMPTY_FILE_BOX_CONTENT);
      setPictureLabel(EMPTY_FILE_BOX_CONTENT);
    } else {
      console.log("Edycja gwiazdy - ustawianie etykiet z props");
      if (props.data.position) {
        setPositionLabel(props.data.position.replace('/images/', ''));
      }
      if (props.data.picture) {
        setPictureLabel(props.data.picture.replace('/images/', ''));
      }
    }
  }, [props.data]);
  
  

  const handleBackButtonClick = () => {
    sessionStorage.removeItem('starId');
    sessionStorage.removeItem("isAddingStar"); 
    setPositionLabel(EMPTY_FILE_BOX_CONTENT);
    setPictureLabel(EMPTY_FILE_BOX_CONTENT);
    navigate(-1); 
  };

  const { control, handleSubmit } = useForm<IAttachmentInput>();
  const onSubmit: SubmitHandler<IAttachmentInput> = async (data) => {
    const { position, picture } = data;
    const bandId = sessionStorage.getItem('starId');
    const SETTING_URL = bandId ? `admin/images/setting/${bandId}` : '/images/setting';
    const BAND_URL = bandId ? `admin/images/band/${bandId}` : '/images/band';
    sessionStorage.removeItem("isAddingStar"); 
    console.log(bandId);

    try {
      if (position) {
        let settingFormData = new FormData();
        settingFormData.append('setting', position);
        await axiosPrivate.post(SETTING_URL, settingFormData);
        sessionStorage.removeItem("starId");
      }

      if (picture) {
        let bandFormData = new FormData();
        bandFormData.append('band', picture);
        await axiosPrivate.post(BAND_URL, bandFormData);
        sessionStorage.removeItem("starId");
      }

      setResult(true);
    } catch (error) {
      setResult(false);
    }

    setOpen(true);
  };

  return (
    <form className="attachment-container" onSubmit={handleSubmit(onSubmit)}>
      <h2>Załączniki</h2>
      <div className="attachment-content">
        <Controller
          name="position"
          control={control}
          render={({ field: { value, onChange, ...field } }) => (
            <div className="file-container">
              <label>Ustawienie na scenie</label>
              <input
                {...field}
                onChange={(e) => {
                  onChange(e.target.files?.[0]);
                  setPositionLabel(e.target.files?.[0]?.name || EMPTY_FILE_BOX_CONTENT); 
                }}
                type="file"
                accept="image/*"
                id="position"
              />
              <label className="file-input" htmlFor="position">
                {positionLabel}
              </label>
            </div>
          )}
        />
        <Controller
          name="picture"
          control={control}
          render={({ field: { value, onChange, ...field } }) => (
            <div className="file-container">
              <label>Zdjęcie zespołu</label>
              <input
                {...field}
                onChange={(e) => {
                  onChange(e.target.files?.[0]);
                  setPictureLabel(e.target.files?.[0]?.name || EMPTY_FILE_BOX_CONTENT);
                }}
                type="file"
                accept="image/*"
                id="picture"
              />
              <label className="file-input" htmlFor="picture">
                {pictureLabel}
              </label>
            </div>
          )}
        />
      </div>
      <Button variant="contained" type="submit" size="large">
        {SUBMIT_BUTTON_TITLE}
      </Button>
      <Button variant="contained" size='large' onClick={handleBackButtonClick}>Powrót</Button>
      <MessageBox open={open} setOpen={setOpen} error={!result} />
    </form>
  );
};

export default AttachmentSegment;
